import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useI18n } from '../../../../context/occ/hooks/use-i18n';
import { useOccConfig } from '../../../../context/occ/hooks/use-occ-config';
import { getMemberSubscriptionName } from '../../../../utils/get-member-subscription-name';
import { getMemberSubscriptionTags } from '../utils/get-tags';
import { getSubscriptionEndDate, getSubscriptionReactivationDate, isSubscriptionActive, isSubscriptionOnHold } from '../utils/status-utils';
import { MemberSubscriptionBase } from './base';
const b = bemClassBuilder('v-member-subscription-non-recurring');
export const MemberSubscriptionNonRecurring = observer(props => {
    const i18n = useI18n();
    const { member: { subscriptions: subscriptionsConfig } } = useOccConfig();
    const { memberSubscriptions, isFuture, displayText, events } = props;
    const memberSubscription = isFuture && memberSubscriptions.future ? memberSubscriptions.future : memberSubscriptions.current;
    return (_jsx("div", Object.assign({ className: b.block() }, { children: _jsx(MemberSubscriptionBase, { name: getMemberSubscriptionName(i18n, memberSubscription), supportingDate: getExpiryLabel(memberSubscription, displayText, i18n, isFuture), tags: [
                { label: displayText.nonRecurringSubscriptionTagLabel },
                ...getMemberSubscriptionTags(memberSubscription, !!isFuture, displayText, subscriptionsConfig)
            ], description: getDescriptionLabel(memberSubscriptions, memberSubscription, displayText, i18n, isFuture), primaryButtonProps: getPrimaryButtonProps(memberSubscriptions, displayText, events, isFuture) }) })));
});
MemberSubscriptionNonRecurring.displayName = 'MemberSubscriptionNonRecurring';
const getExpiryLabel = (memberSubscription, displayText, i18n, isFuture) => {
    return isFuture
        ? undefined
        : i18n.displayTextLabel(displayText.endDateLabel, {
            date: getSubscriptionEndDate(memberSubscription)
        });
};
const getDescriptionLabel = (memberSubscriptions, memberSubscription, displayText, i18n, isFuture) => {
    const showActiveAgainDate = isSubscriptionOnHold(memberSubscription) && memberSubscription.holdPeriod;
    const showCanRenewOnDate = isSubscriptionActive(memberSubscription) &&
        memberSubscriptions.canPurchaseFutureSubscriptionAt &&
        !memberSubscriptions.canPurchaseFutureSubscription &&
        !memberSubscriptions.future;
    if (isFuture) {
        return i18n.displayTextLabel(displayText.futureNonRecurringSubscriptionLabel, {
            futureSubscriptionStartDate: memberSubscription.startsAt,
            futureSubscriptionEndDate: memberSubscription.expiresAt
        });
    }
    else if (showActiveAgainDate) {
        return i18n.displayTextLabel(displayText.activeAgainLabel, {
            activeAgainDate: getSubscriptionReactivationDate(memberSubscription)
        });
    }
    else if (showCanRenewOnDate) {
        return i18n.displayTextLabel(displayText.canRenewOnLabel, {
            canRenewOnDate: memberSubscriptions.canPurchaseFutureSubscriptionAt
        });
    }
};
const getPrimaryButtonProps = (memberSubscriptions, displayText, events, isFuture) => {
    if (isFuture)
        return; // They already have a future subscription, no need to show the renewal button.
    if (memberSubscriptions.canPurchaseFutureSubscription) {
        return { children: displayText.renewSubscriptionButtonLabel, onClick: events.onRenewButtonClicked };
    }
};
